export default __webpack_public_path__ + "static/media/CSUSHI.362cd0d2.png";